import SportStatTypeGroups from "./SportStatTypeGroups";
export default SportStatTypeGroups;
